import { SubscriptionInfo } from './revenueCat'

// RevenueCat represents lifetime/non-expiring entitlements with a far-future
// expiry date. Anything in or beyond this year is treated as lifetime.
const LIFETIME_EXPIRY_YEAR = 2099

export default function isLifetimeSubscription(
  subscription: SubscriptionInfo,
): boolean {
  return (
    subscription.expiresDate !== null &&
    subscription.expiresDate.getFullYear() >= LIFETIME_EXPIRY_YEAR
  )
}
